import type { TranslationResources } from './zh-CN';

export const enUS = {
  common: {
    studentProfileChangeRequest: {
      loadError: 'Unable to load change request',
      notFound:
        'The request does not exist or you do not have permission to view it.',
      back: 'Back to change history',
      title: 'Student Information Change Request',
      changes: 'Requested Changes',
      changesHint: 'Highlighted values are the requested changes.',
      source: 'Submitted By',
      submittedAt: 'Submitted At',
      empty: 'No field changes to display',
      viewProfile: 'View Current Student Information',
      awaitingReview: 'Awaiting Your Review',
      rejectionReason: 'Rejection Reason',
      reasonPlaceholder: 'Optional: explain what needs to be corrected',
      reasonHint: 'Sent to the applicant only on rejection.',
      approve: 'Approve and Apply Changes',
      reject: 'Reject Request',
      actionError: 'Unable to process the request. Please try again later.',
      before: 'Before',
      after: 'After',
      fullName: 'Name',
      gender: 'Gender',
      schoolProfile: 'Accommodation and Address',
      boardingStatus: 'Boarding Status',
      dormitoryNumber: 'Dormitory Number',
      dayStudentAddress: 'Day Student Address',
      homeAddress: 'Home Address',
      pending: 'Pending Review',
      approved: 'Approved',
      rejected: 'Rejected',
      applied: 'Applied',
      studentSource: 'Submitted by Student',
      guardianSource: 'Submitted by Guardian',
      advisorSource: 'Updated by Class Advisor',
      adminSource: 'Updated by School Administrator',
      notFilled: 'Not Provided',
      male: 'Male',
      female: 'Female',
      boarding: 'Boarding',
      dayStudent: 'Day Student',
      yes: 'Yes',
      no: 'No',
      updated: 'Updated',
      rejectedTitle: 'Request Rejected',
      approvedTitle: 'Request Approved',
      appliedTitle: 'Changes Applied',
      processedTitle: 'Request Processed',
      rejectedDescription:
        'These changes will not be applied to the student profile.',
      approvedDescription:
        'These changes have been approved and will be applied according to the workflow.',
      appliedDescription:
        'These changes have been applied to the student profile.',
      processedDescription:
        'No further action is currently required for this request.',
      loading: 'Loading change request',
      retryLater: 'Please try again later.',
      changeCount: '{{count}} item(s)',
    },
    actions: {
      retry: 'Retry',
      back: 'Go back',
      backHome: 'Back to home',
      relogin: 'Log in again',
    },
    language: { label: 'Language', zhCN: '简体中文', enUS: 'English' },
    theme: { toDark: 'Switch to dark mode', toLight: 'Switch to light mode' },
    forbidden: {
      title: '403 · Access denied',
      description: 'You do not have permission to access this page.',
    },
    notFound: {
      title: 'Page not found',
      description:
        'The page does not exist, has moved, or is not available in this version.',
    },
  },
  shell: {
    account: 'Account',
    overview: 'Overview',
    workspaces: 'Workspaces',
    createOrJoin: 'Create or join an organization',
    logout: 'Log out',
    loading: 'Loading…',
    enteringWorkspace: 'Entering workspace…',
    backToWorkspaces: 'Back to workspace selection',
    userFallback: 'User',
    notifications: 'Notifications',
    unreadNotifications: '{{count}} unread notifications',
    myWorkspaces: 'My workspaces',
    currentWorkspace: 'Current workspace',
    currentWorkspaceSettings: 'Current workspace settings',
    accountActions: 'Account',
    useInvitationCode: 'Use invitation code',
    switchWorkspace: 'Switch workspace',
    noWorkspaces: 'No workspaces available',
    groups: {
      teaching: 'Teaching',
      management: 'Administration',
      collaboration: 'Collaboration',
      personal: 'Personal',
      setup: 'Setup',
    },
    navigation: {
      overview: 'Overview',
      myCourses: 'My courses',
      myClasses: 'My classes',
      quizzes: 'Assignments',
      myQuizzes: 'My assignments',
      grading: 'Grading',
      grades: 'Grades',
      attendance: 'Attendance',
      leave: 'Leave',
      timetable: 'Calendar',
      members: 'Members',
      classes: 'Classes',
      academics: 'Academic years & terms',
      questions: 'Question bank',
      collaboration: 'School collaboration',
      courses: 'Courses',
      programs: 'Programs',
      platform: 'Tenant management',
      aiWorkspace: 'AI workspace',
      inbox: 'Messages',
      materials: 'Materials',
      families: 'Families',
      parentCenter: 'Parent center',
      settings: 'Settings',
      studentProfile: 'Student profile',
    },
    roles: {
      owner: 'Owner',
      admin: 'Administrator',
      schoolAdmin: 'School administrator',
      teacher: 'Teacher',
      headTeacher: 'Head teacher',
      student: 'Student',
      guardian: 'Guardian',
      member: 'Member',
    },
  },
} as const satisfies TranslationResources;
